// lib
import { createApi } from "@reduxjs/toolkit/query/react";
// utils
import { baseQuery, convertTag } from "src/utils/baseQuery";
// configs
import { ENDPOINTS, METHODS } from "src/constants/API";
import { apiHelper } from "src/utils/apiHelper";
import { IMeetings, IMeetingsQuery } from "src/types/meetings.types";

const TAGS = {
  list: "tag-meetings-list",
};

export const MeetingsApi = createApi({
  reducerPath: "meetings-api",
  baseQuery: baseQuery(true),
  tagTypes: Object.values(TAGS).map((t) => t),
  endpoints: (builder) => ({
    getMeetingsList: builder.query<IMeetings, IMeetingsQuery>({
      providesTags: [convertTag(TAGS.list)],
      query: (body) => apiHelper(ENDPOINTS.meetings.list, body),
    }),
    // getMeetingValidateTime: builder.mutation({
    //   query: (body) => ({
    //     url: ENDPOINTS.meetings.validateEmail,
    //     method: "POST",
    //     body,
    //   }),
    // }),
    updateMeeting: builder.mutation({
      invalidatesTags: [convertTag(TAGS.list)],
      query: (body) => ({
        url: ENDPOINTS.meetings.update,
        method: "POST",
        body,
      }),
    }),
    getMeetingValidTimes: builder.mutation<
      { result: Array<string> },
      { date: string }
    >({
      query: (body) => ({
        url: apiHelper(ENDPOINTS.meetings.getValidTimes, body),
        method: "GET",
      }),
    }),
    countries: builder.query<
      { countries: Array<{ name: string; _id: string }> },
      unknown
    >({
      query: () => ENDPOINTS.countries.list,
    }),
  }),
});

export const {
  useGetMeetingsListQuery,
  useGetMeetingValidTimesMutation,
  useUpdateMeetingMutation,
  useCountriesQuery,
} = MeetingsApi;
